<template>
  <div class="disengaged-emp-to-meet-wrap">
    <v-row no-gutters class="pb-1">
      <v-col cols="8"></v-col>
      <v-col cols="4" class="d-flex justify-end">
        <div class="d-flex align-center" v-if="table.totalItems && table.totalItems > 0">
          <div class="pre-icon cursor-pointer mr-3 pt-1" @click="displayPre()">
            <i class="las la-chevron-circle-left"></i>
          </div>
          <div>{{getPreNumber}} - {{getNextNumber}} of {{table.totalItems}}</div>
          <div class="next-icon cursor-pointer ml-3 pt-1" @click="displayNext()">
            <i class="las la-chevron-circle-right"></i>
          </div>
        </div>
      </v-col>
    </v-row>
    <div class="employee-lists">
      <v-row
        class="emp-card box-container intro-x"
        :id="index"
        no-gutters
        v-for="(e, index) in table.team" :key="index"
      >
        <v-col cols="12" lg="3" class="emp-action align-self-center text-left">
          <div class="emp-checkbox">
            <!-- <v-checkbox
              :id="index.toString()"
              :class="e.id"
              dense
              :ripple="false"
              hide-details
              class="ma-0 emp-check"
              color="primary"
              v-model="isEmployeeSelected[e.id]"
              @change="updateSelectEmployees(e, $event)"
              >
            </v-checkbox> -->
          </div>
          <div class="emp-avatar">
            <div class="star-icon">
              <v-icon v-if="e.user_high_potential_emp">fas fa-star</v-icon>
            </div>
            <div class="emp-profile-image">
              <img v-if="e.profilePicture" :src="e.profilePicture" :alt="e.display_name">
              <img v-else :src="getImgUrl('male-avatar')" :alt="e.user_display_name">
            </div>
          </div>
          <div class="emp-desc-wrap">
            <div class="emp-desc">
              <div class="emp-name hover-link cursor-pointer" @click="viewEmp(e)">
                <span v-if="e.user_display_name" :title="e.user_display_name">{{e.user_display_name}}</span>
                <span v-else>--</span>
              </div>
              <div class="emp-department">
                <span v-if="e.user_department" :title="e.user_department">{{e.user_department}}</span>
                <span v-else>--</span>
              </div>
              <div class="emp-email">
                <span v-if="e.user_email" :title="e.user_email">{{e.user_email}}</span>
                <span v-else>--</span>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" lg="4" class="align-self-center text-center">
          <v-row no-gutters class="align-center">
            <v-col class="text-center">
              <div class="emp-mood" v-if="e.overall_mood">
                <img :src="getImgUrl(e.overall_mood)" :alt="e.overall_mood">
              </div>
              <div v-else>--</div>
              <div class="emp-sub">
                Employee vibe
              </div>
            </v-col>
            <v-col class="text-center">
              <div class="emp-milestone" v-if="e.stage_title">
                {{e.stage_title}}
              </div>
              <div v-else>--</div>
              <div class="emp-sub">
                Last touchpoint
              </div>
            </v-col>
            <v-col class="text-center">
              <div class="emp-engagement" v-if="e.driverAverage">
                {{e.driverAverage}}
              </div>
              <div v-else>--</div>
              <div class="emp-sub">
                Engagement score
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="4" class="align-self-center text-center">
          <v-row no-gutters>
            <v-col class="align-self-center text-center">
              <div class="emp-resolution" v-if="e.action_status &&
                e.action_status !== 'Na'
              ">
                {{e.action_status.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}
                <span class="cursor-pointer" @click="openDialog(e, 'ResolutionStatus', ['manage_employee'])">
                  <i class="las la-pencil-alt" style="font-size: 16px !important"></i>
                </span>
              </div>
              <div v-else>--</div>
              <div class="emp-sub">
                Resolution status
              </div>
            </v-col>
            <v-col class="align-self-center text-center">
              <!-- <div v-if="e.last_chat_assignedTo_display_name"> -->
                <div class="emp-assigned" v-if="e.assignedTo_display_name">
                  {{e.assignedTo_display_name}}
                  <span class="cursor-pointer" @click="openDialog(e, 'AssignedTo', ['manage_employee'])">
                    <i class="las la-pencil-alt" style="font-size: 16px !important"></i>
                  </span>
                </div>
                <div v-else>--</div>
                <div class="emp-sub">
                  Assigned to
                </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="1" class="align-self-center text-center">
          <v-row no-gutters>
            <v-col class="align-self-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    slot="activator"
                    icon
                    class="box-container zoom-in emp-action-btn"
                    @click="openDialog(e, 'AssignedTo', ['manage_employee'])"
                  >
                    <v-icon>las la-users-cog</v-icon>
                  </v-btn>
                </template>
                Assigned To
              </v-tooltip>
            </v-col>
            <v-col class="align-self-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    slot="activator"
                    icon
                    class="box-container zoom-in emp-action-btn"
                    @click="openDialog(e, 'ResolutionStatus', ['manage_employee'])"
                  >
                    <v-icon>las la-tasks</v-icon>
                  </v-btn>
                </template>
                Resolution Status
              </v-tooltip>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <!-- dialogs start -->
    <one-on-one
      ref="OneOnOne"
      @getEmployee="getEmployeesToMeet"
    ></one-on-one>
    <acknowledge
      ref="Acknowledge"
      @getEmployee="getEmployeesToMeet"
    ></acknowledge>
    <assigned-to
      type="employeesToMeet"
      :assignedToList="assignedToList"
      @assignEmployee="assignEmployee"
      ref="AssignedTo"
    ></assigned-to>
    <resolution-status
      type="employeesToMeet"
      ref="ResolutionStatus"
      @onClickUpdateStatus="onClickUpdateStatus"
    ></resolution-status>
    <!-- dialogs end -->
    <resolutionSummary
      type="employeesToMeet"
      ref="Resolutionsummary"
      @onClickUpdateStatus="onClickUpdateStatus">
    </resolutionSummary>
  </div>
</template>

<script>
import axios from 'axios';
import AssignedTo from '../../employees/dialogs/assigned-to';
import ResolutionStatus from '../../employees/dialogs/resolution-status';
import ResolutionSummary from '../../employees/dialogs/ResolutionSummary';
import OneOnOne from '../../employees/dialogs/OneOnOne';
import Acknowledge from '../../employees/dialogs/Acknowledge';
import DisengagedMixin from './disengaged-mixin';

export default {
  name: 'DisengagedEmpToMeet',

  components: {
    OneOnOne,
    Acknowledge,
    AssignedTo,
    ResolutionStatus,
    ResolutionSummary
  },

  mixins: [DisengagedMixin],

  data () {
    return {
      config: {
        actionMenu: {},
        activeTab: 'high_risk_session',
        panel: [true, true, true, true],
        initialLoading: true,
        loading: false,
        initialLoadingFilters: true
      },
      activeDriver: false,
      table: {
        totalItems: 0,
        team: []
      },
      pagination: {
        rowsPerPage: 10,
        page: 1
      },
      assignedToList: [],
      actionStatus: '',
      employeeFilters: {}
    };
  },

  computed: {
    getPreNumber () {
      const num = (this.pagination.page - 1) * this.pagination.rowsPerPage + 1;
      if (num > this.table.totalItems) {
        return this.table.totalItems;
      }
      return num;
    },
    getNextNumber () {
      const num = (this.pagination.page - 1) * this.pagination.rowsPerPage + this.pagination.rowsPerPage;
      if (num > this.table.totalItems) {
        return this.table.totalItems;
      }
      return num;
    }
  },

  watch: {
    $route () {
      if (this.$route.query && this.$route.query.driver) {
        this.activeDriver = true;
      } else {
        this.activeDriver = false;
      }
    }
  },

  beforeMount () {
    if (this.$route.query && this.$route.query.disengaged) {
      this.actionStatus = this.$route.query.disengaged;
    }
    this.getAdminUsers();
    this.getEmployeesToMeet();
  },

  methods: {
    viewEmp (emp) {
      this.$router.push({ path: `/employees/view/${emp.user_profile_id}` }).catch(() => {});
    },
    displayPre () {
      if (this.pagination.page > 1) {
        this.pagination.page = this.pagination.page - 1;
        this.getEmployeesToMeet();
      }
    },
    displayNext () {
      if (this.pagination.page < (this.table.totalItems / 10)) {
        this.pagination.page = this.pagination.page + 1;
        this.getEmployeesToMeet();
      }
    },
    getEmployeesToMeet () {
      const filters = Object.assign({}, this.updateDashboardFilters);
      if (filters && filters.filters) {
      // filters.filters have the dynamic filters value
        delete filters.filters;
      }
      let queryParams = {
        ...filters
      };
      if (this.updateDashboardFilters && this.updateDashboardFilters.filters) {
        this.$lodash.each(this.updateDashboardFilters.filters, (v, k) => {
          if (v.length > 0) {
            queryParams[`user__profile__${k}__in`] = v.join();
          }
        });
      }
      const params = {
        count: true,
        action_status__in: this.actionStatus ? this.actionStatus : undefined,
        page_limit: this.pagination.rowsPerPage,
        page_offset: this.pagination.page || undefined,
        // fields: 'user_display_name,user_email,user_department,stage_title,completedAt,session_driver,overall_mood,driverAverage,transcripts,user_profile_id,status,action_status,createdAt,',
        fields: 'user_display_name,user_email,user_department,stage_title,completedAt,session_driver,overall_mood,driverAverage,transcripts,user_profile_id,status,action_status,createdAt,assignedTo,assignedTo_email,assignedTo_display_name,user_high_potential_emp'
      };
      queryParams = {
        ...queryParams,
        ...params
      };
      if (this.$route.name === 'ViewLifecycle' && this.$route.params && this.$route.params.stageId) {
        const temp = {
          stage_id: this.$route.params.stageId
        };
        queryParams = {
          ...queryParams,
          ...temp
        };
      }
      if (this.$route.query && this.$route.query.snapshot) {
        queryParams = {
          ...queryParams,
          ...JSON.parse(this.$route.query.snapshot)
        };
      }
      axios.get(`${process.env.VUE_APP_API_URL}disengaged/employees`, {
        params: queryParams
      }).then((response) => {
        if (response && response.data) {
          if (response.data.disengaged_users) {
            // this.config.initialLoading = false;
            this.table.team = response.data.disengaged_users;
            // this.$lodash.each(this.table.team, (v) => {
            //   if (v.action_status === 'Na') {
            //     v.action_status = '';
            //   }
            // });
            // const actionMenu = {};
            // this.$lodash.each(response.data.disengaged_users, (v) => {
            //   actionMenu[v.id] = false;
            // });
            // this.config.actionMenu = actionMenu;
            this.table.totalItems = response.data.count;
          }
        } else {
          // this.config.initialLoading = false;
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to fetch details, Please try again later!'
          });
        }
      });
    },
    checkPermission (permission) {
      let flag = false;
      this.$lodash.each(this.user.permissions, (perm) => {
        this.$lodash.each(permission, (v) => {
          if (v === perm) {
            flag = true;
          }
        });
      });
      return flag;
    },
    getImgUrl (pet) {
      const images = require.context('@/assets/', false, /\.png$/);
      return images(`./${pet}.png`);
    },
    getAdminUsers (emp) {
      const tempList = [];
      axios.get(`${process.env.VUE_APP_API_URL}users/admins`).then((response) => {
        if (response && response.data.data && response.data.data.length > 0) {
          this.$lodash.each(response.data.data, (val) => {
            const t = {};
            t.text = val.display_name;
            t.id = val.user_id;
            tempList.push(t);
          });
        } else {
          const noData = {};
          noData.title = 'No data available';
          noData.id = null;
          tempList.push(noData);
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to get details, Please try again later!'
          });
        }
      });
      this.assignedToList = []; // for reset the existing data
      this.assignedToList = tempList;
    },
    onClickUpdateStatus (val) {
      if (val.status.status === 'acknowledged') {
        this.openDialog(val.emp, 'Acknowledge', ['acknowledge_chat']);
      }
      if (val.status.status === 'scheduled') {
        this.openDialog(val.emp, 'OneOnOne', ['schedule_invite']);
      }
      if (val.status.status === 'inProgress') {
        this.updateStatus(val.emp, 'inProgress', ['change_status']);
      }
      if (val.status.status === 'resolved') {
        this.updateStatus(val.emp, 'resolved', ['change_status']);
        // this.openDialog('Resolutionsummary');
      }
    },
    updateStatus (data, value, permission) {
      // for update resolution status
      if (this.checkPermission(permission)) {
        this.updateEmployeeSession(data.id, value, 'status');
      } else {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Unable to update status, You don\'t have permission!'
        });
      }
    },
    assignEmployee (val) {
      if (val.last_chat_id) {
        this.updateAssignedTo(val.last_chat_id, val.id);
      } else {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Unable to update status, Please try again later!'
        });
      }
    },
    updateAssignedTo (id, val) {
      this.updateEmployeeSession(id, val, 'assign');
    },
    openDialog (data, type, permission) {
      // console.log('data, type, permission', data, type, permission, this.$refs);
      if (this.checkPermission(permission)) {
        if (type && this.$refs[type]) {
          this.$refs[type].open = true;
          this.$refs[type].employee = data;
        }
      } else {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Unable to update status, You don\'t have permission!'
        });
      }
    },
    updateEmployeeSession (id, val, type) {
      // this.config.loading = true;
      const queryParams = {};
      if (type === 'status') {
        queryParams.action_status = val; // for resolution status
      }
      if (type === 'assign') {
        queryParams.assignedTo_id = val; // for assigned to
      }
      axios.patch(`${process.env.VUE_APP_API_URL}session/update/${id}`, {
        ...queryParams
      }).then((response) => {
        this.config.loading = false;
        if (response && response.data) {
          // s.action_status = newStatus;
          // s.assignedTo = assignedTo;
          this.$store.dispatch('updateSnackbar', {
            color: 'info',
            show: true,
            text: 'Employee status updated!'
          });
          this.getEmployeesToMeet();
        } else {
          this.config.loading = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to update status, Please try again later!'
          });
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to update status, Please try again later!'
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.disengaged-emp-to-meet-wrap {
  padding: 12px;
  .employee-lists {
    .emp-card {
      .emp-action-btn {
        box-shadow: none !important;
      }
      padding: 12px;
      margin: 0 0 16px 0;
      background-color: var(--bg);
      position: relative;
      .emp-action {
        position: relative;
        display: flex;
        .emp-avatar {
          margin: 0 12px;
        }
        .emp-checkbox,
        .emp-avatar {
          display: flex;
          position: relative;
          align-items: center;
        }
        .star-icon {
          position: absolute;
          top: 4px;
          left: -6px;
          i {
            color: #fdd835 !important;
            font-size: 20px !important;
          }
        }
        .emp-profile-image {
          img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
          }
        }
      }
      .emp-desc-wrap {
        overflow: hidden;
        .emp-desc {
          .emp-name {
            font-size: var(--content-size);
            color: var(--color-text);
          }
          .emp-department, .emp-email {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: var(--content-caption);
            color: var(--color-palceholder);
          }
        }
      }
      .emp-mood {
        img {
          width: 30px;
          height: 30px;
        }
      }
      .emp-sub {
        font-size: var(--content-caption);
        color: var(--color-palceholder);
      }
      .emp-resolution {
        text-transform: capitalize;
      }
    }
  }
}
</style>
